import { EventEmitter, OnChanges, Output } from "@angular/core";
import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BcRevenueTransactionsData } from "../../../../core/models/bcLedger/BcRevenueTransactionsResponseDto";
import { SalesCommissionRequestDto } from "../../../../core/models/bcLedger/salesCommissionRequestDto";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcLedgerStacker } from "../../../../core/models/bcLedger/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { BcRevenueTransactionsComponent } from "../bc-revenue-transactions/bc-revenue-transactions.component";
import { BcledgerService } from "../../../../core/services/bcledger.service";

@Component({
  selector: "jni-total-sales-commissions-adjustments",
  templateUrl: "./total-sales-commissions-adjustments.component.html",
  styleUrls: ["./total-sales-commissions-adjustments.component.scss"],
  imports: [BcRevenueTransactionsComponent],
})
export class TotalSalesCommissionsAdjustmentsComponent
  implements OnInit, OnChanges
{
  @Input() bcLedgerStacker!: BcLedgerStacker;
  totalSalesCommissionsAdjustmentsParams!: SalesCommissionRequestDto;
  totalSalesCommissionsAdjustmentsList: BcRevenueTransactionsData[] = [];
  TotalBCRevenue!: number;
  TotalBCGP!: number;
  BCAvgMargin!: number;
  TotalBCCommission!: number;
  TotalBCReserve!: number;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private _totalSalesCommissionsAdjustmentsService: BcledgerService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.totalSalesCommissionsAdjustmentsParams = {
        ...params,
      } as SalesCommissionRequestDto;
      this.totalSalesCommissionsAdjustmentsParams.CategoryID = "";
    });
  }

  ngOnInit(): void {
    this.getTotalSalesCommissionsAdjustments(
      this.totalSalesCommissionsAdjustmentsParams
    );
  }

  getTotalSalesCommissionsAdjustments(payload: SalesCommissionRequestDto) {
    this._loaderService.setLoaderState(true);
    this._totalSalesCommissionsAdjustmentsService
      .totalSalesCommissionsAdjustments(payload)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.totalSalesCommissionsAdjustmentsList = res.data.Data ?? [];
            this.TotalBCRevenue = res.data.TotalBCRevenue;
            this.TotalBCGP = res.data.TotalBCGP;
            this.BCAvgMargin = res.data.BCAvgMargin;
            this.TotalBCCommission = res.data.TotalBCCommission;
            this.TotalBCReserve = res.data.TotalBCReserve;
            return;
          }
          this._toastrService.error(res.message ?? "No results found", "Error");
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error("No results found", "Error");
        },
      });
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.totalSalesCommissionsAdjustmentsParams = { ...this.bcLedgerStacker };
      this.totalSalesCommissionsAdjustmentsParams.CategoryID = "";
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
